<script lang="ts">
    import { onMount } from "svelte"
    import Markdown from "./Markdown.svelte"
    import { animateOnVisible } from "../../../configs/config"

    let {
        block,
    }: {
        block: GrayTextBlocks
    } = $props()
    let ulEl: HTMLElement | null = $state(null)
    onMount(() => {
        let liEls = ulEl?.querySelectorAll("li")

        animateOnVisible(liEls, {
            opacity: [0, 1],
            scale: [0.5, 1],
            duration: 300,
            delay: (_, i) => i * 100,
            easing: "easeInOutQuad",
        })
    })
</script>

<ul bind:this={ulEl}>
    {#each block.content.texts as box}
        <li>
            <Markdown text={box.text} />
        </li>
    {/each}
</ul>

<style lang="less">
    @import "../../../css/variables.less";

    ul {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 1.2rem;
        li {
            width: 100%;
            border-radius: 4px;
            background: var(--bg-200);
            padding: 1.2rem;
        }
        @media @max-mobile {
            display: flex;
            flex-direction: column;
        }
    }
</style>
